import { countries, normalizedCountries } from '../lib/countries.js'
import { seriesEsp, seriesEng, seriesId, countriesDataEng, countriesDataEsp } from './translations/translations_frp_ahdi.js';
import { translateSeries } from '../lib/translate_series_name.js'

export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

    constructor(params) {
      this.charts = params || [];
      this.setDefaults();

      return {
        charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
        ranges: this.RANGES_DEFAULT,
        endpoints: {
          series: this.series,
          data: {
            build: () => {
              const sql = 'select+*+from+ahdi';
              const gobiertoPath = process.env.GOBIERTO_DATA_URL
              const token = process.env.GOBIERTO_DATA_TOKEN
              const query = `?sql=${sql}&token=${token}`;

              return `${gobiertoPath}/api/v1/data/data.json${query}`;
            },
            parse: data => {
              this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, null, null, null, null)
              const series = this.series.map(d => ({
                id: d.id,
                name: d.name
              }));

              const { data: rawData } = data
              rawData.map(d => {
                const { geo_item } = d

                const indexNormalizedCountries = countries.findIndex(element => element === geo_item);

                if (indexNormalizedCountries >= 0) {
                  d.geo_item = normalizedCountries[indexNormalizedCountries]
                }
              })

              rawData.map(d => {
                const { geo_item } = d
                if (d.geo_item) {
                  const selectedLanguage = document.documentElement.lang === 'es' ? countriesDataEsp : countriesDataEng
                  const indexCountry = countriesDataEng.findIndex(country => country === geo_item);
                  d.geo_item = selectedLanguage[indexCountry]
                }
              })
              // reorder the return data to be grouped by kind of serie
              const groupBySerie = series.map(set =>
                rawData.map(d => ({
                  serie: set.id,
                  time: new Date(d["year"], 0, 1),
                  value: parseFloat(d[set.id]),
                  name: set.name,
                  geo_item: d.geo_item
                }))
              );

              const groupMapData = {
                groups: groupBySerie.flat(),
                raw: rawData
              }

              return groupMapData;
            }
          }
        }
      };
    }

    setDefaults = () => {
      this.series = [{
          id: "adjusted_income_index"
        },
        {
          id: "life_expectancy_index"
        },
        {
          id: "schooling_index"
        },
        {
          id: "liberal_democracy_index"
        },
        {
          id: "ahdi"
        },
        {
          id: "ahdi_excluding_income"
        }
      ];

      const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
      this.RANGES_DEFAULT = range(1870, 2016);

      this.CHARTS_DEFAULT = [{
          type: "Line",
          btnPlaceholder: "Añadir serie",
          pivotPlaceholder: 'Seleccionar países',
          xAxisProp: "time",
          yAxisProp: "value",
          aggregationProp: "serie",
          bspline: true,
          tooltip: this.tooltipCommon,
          cache: true,
          tickFormatY: (...args) => {
            const [d, , , d3] = args;

            return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
          }
        },
        {
          type: "Stacked",
          btnPlaceholder: "Añadir serie",
          xAxisProp: "time",
          yAxisProp: "value",
          aggregationProp: "serie",
          tooltip: this.tooltipCommon,
          cache: true,
          tickFormatY: (...args) => {
            const [d, , , d3] = args;

            return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
          }
        },
        {
          type: "Map",
          mapProperty: "ahdi",
          mapPropertyInverted: false,
          geoTypeProp: "geo_type",
          geoItemProp: "geo_item",
          titleLegend: "",
          language: 'es',
          timeLine: true
        },
        {
          type: "MapContainer",
          data: "ahdi",
          mapProperty: "ahdi",
          mapPropertyInverted: false,
          geoTypeProp: "geo_type",
          geoItemProp: "geo_item",
          geoItemFilter: "country",
          titleLegend: "",
          scaleDomain: [0.001, 0.166, 0.250, 0.375, 0.500, 0.625, 0.750, 1.000],
          colors: ['#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8'],
          language: 'es',
          firstYear: 1870,
          pivotTableValue: 'geo_item',
          xAxisProp: "time",
          yAxisProp: "value",
          aggregationProp: "serie",
          tooltip: this.tooltipCommon,
          cache: true,
          hasContainer: true,
          timeLine: true,
          pivotTableSelector: true,
          showScales: false,
          tickFormatY: (...args) => {
            const [d, , , d3] = args;

            return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
          }
        }
      ];
    };

  }
